<template>
	<nuxt-link :to="item.filename ? localePath(`/${item.filename}`) : item.link" class="slick-item columns">
		<div class="slick-slide-content">
			<h3>{{ item.header }}</h3>
			<p>{{ item.tagline }}</p>
			<span>
				{{ $t('viewThisHotel') }}
				<font-awesome-icon icon="fa-light fa-arrow-right-long" size="1x" />
			</span>
		</div>

		<div class="image-container">
			<picture>
				<source
					v-if="item.overviewImageWebp || item.imageWebp || item.imageOverviewPortraitWebp"
					:srcset="item.overviewImageWebp || item.imageWebp || item.imageOverviewPortraitWebp"
					type="image/webp"
				/>
				<source :srcset="item.overviewImage || item.image || item.imageOverviewPortrait" />
				<img
					loading="lazy"
					:src="item.overviewImage || item.image || item.imageOverviewPortrait"
					:alt="item.overviewImageAlt || item.imageAlt || item.imageOverviewPortrait || ''"
				/>
			</picture>
		</div>
	</nuxt-link>
</template>

<script setup>
defineProps({
	item: { type: Object, required: true },
	localePath: { type: Function, required: true },
});
</script>

<style lang="scss" scoped>
.slick-slide {
	width: unset;
	margin: 0;
	padding-right: 20px;
}

.slick-item {
	position: relative;
	padding: 0;
	width: 32%;
	background-color: var(--alternating-background-color);
	border-bottom: 1px solid var(--header-color);

	.room-icons {
		position: absolute;
		z-index: 3;
		color: #fff;
		padding: 20px;
		display: flex;
		gap: 10px;
	}

	.slick-slide-content {
		position: absolute;
		bottom: 20px;
		left: 20px;
		right: 20px;
		z-index: 3;
		text-align: left;
		color: var(--header-color);

		h3 {
			line-height: unset;
		}

		h3,
		div {
			color: var(--header-color);
			transition: color 0.3s ease;
		}

		p {
			line-height: 20px;
			font-size: 14px;
			color: #000;
			min-height: 40px;
		}

		div {
			color: #000;
			transition: color 0.3s ease;

			p {
				/* line-height: 28px; */
				font-size: 14px;
				font-weight: 500;
				color: var(--body-color);
			}
		}

		span {
			color: var(--cta-color);
			transition: color 0.3s ease;
			text-transform: uppercase;
			font-size: var(--button-font-size);
			font-weight: 500;
			display: flex;
			justify-content: space-between;
			align-items: center;
			z-index: 999;
		}
	}

	.button-container {
		z-index: 3;
		position: absolute;
		inset: auto 0 0;

		span {
			padding-left: 20px;
			border-top: 1px solid var(--header-color);
			display: flex;
			justify-content: space-between;
			align-items: center;
			text-transform: uppercase;
			font-size: 14px;
			font-weight: 500;

			a {
				margin: 0;
				border-bottom: none;

				&:hover {
					background: var(--header-color);
				}
			}
		}
	}

	.image-container {
		width: 100%;
		position: relative;
		height: 320px;
		margin-bottom: 190px;
		overflow: hidden;
		transition: all 0.3s ease-in-out;

		img {
			width: 100%;
			height: 100%;
			object-fit: cover;
			transition: all 0.3s ease-in-out;
		}

		&::after {
			content: '';
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			background: rgb(0 0 0 / 10%);
			transition: background 0.3s ease-in-out;
			pointer-events: none;
		}
	}

	@media (min-width: 680px) {
		&:hover {
			transition: all 0.3s ease-in-out;

			.slick-slide-content {
				color: white;

				h3,
				span,
				p,
				div {
					color: white;
				}
			}

			.image-container {
				height: 510px;
				margin-bottom: 0;
			}

			.image-container::after {
				background: rgb(0 0 0 / 30%);
			}

			.button-container {
				span {
					border-top: 1px solid #fff !important;
				}
			}
		}
	}
}

.slide-row-nav {
	width: 600px;
	max-width: 100%;
	border-radius: 13px;
	overflow: hidden;
}

.slide-row-nav .slick-slide {
	padding: 0;
	width: calc(100% / 6) !important;
}

.nav-slick-item {
	height: 10px;
	background: #fff;
	transition: all 0.3s ease-in-out;
}

.slick-current .nav-slick-item {
	background: var(--cta-color);
}

@media (max-width: 750px) {
	.slick-item {
		margin: 10px auto;
		width: 100% !important;
	}
}
</style>
